import React, { useState, useEffect } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, Card, Badge, DropdownItem, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, UncontrolledTooltip, Alert, Spinner } from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    PaginationComponent,
    Row,
    Col,
    DataTable,
    DataTableBody,
    DataTableHead,
    DataTableRow,
    DataTableItem,
} from "../../../components/Component";
import { Link } from "react-router-dom";
import { loginAxios } from '../../../config/axios.config';
import { useQuery, useMutation } from "@tanstack/react-query";
import { useSelector, useDispatch } from 'react-redux';
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import './style.scss';

import SingleBarChart from './BarChart';
import NewPieChart from './NewPieChart';
import PieChartPro from './PieChartPro';
import StackedBarChartPro from './StackedBarChartPro';
import StackedBarChartProB from './StackedBarChartProB';
import StackedBarChartProGroup from './StackedBarChartProGroup';
import StackedBarChartProReverseGroup from './StackedBarChartProReverseGroup';
import axios from "axios";
import {checkAndClearExpiredData} from '../../../../src/utils/Utils'

const PurchaseOrderCharts = () => {

    const [purchaseOrderData, setPurchaseOrderData] = useState({});

    const purchaseOrderAPI = async (param) => {
        try {
            const { data } = await loginAxios.get(`dashboard/purchase-order`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken'),
                    'Access-Control-Allow-Origin': '*'
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    
    const purchaseOrderAPICall = useMutation(purchaseOrderAPI, {        
        onSettled(data, error) {
            if (data) {
                
                const now = new Date().getTime();
                const item = {
                    value: data?.data?.finalResponse,
                    timestamp: now
                };

                sessionStorage.setItem("PO_CHARTS_DATA", JSON.stringify(item));
                setPurchaseOrderData(data?.data?.finalResponse)
            }
        }
    });

    useEffect(() => {

        if(sessionStorage.getItem('PO_CHARTS_DATA') == null) {
            purchaseOrderAPICall.mutate();
        } else {
            setPurchaseOrderData(JSON.parse(sessionStorage.getItem('PO_CHARTS_DATA'))?.value);
        }

    },[]);

    setInterval(() => {
        if(checkAndClearExpiredData('PO_CHARTS_DATA')) {
            purchaseOrderAPICall.mutate();
        }
    }, 3600000);
    

    return (<>
        
        <Head title="Charts"></Head>
        
        <Content>            
            <BlockHead size="sm">
                <BlockBetween>
                    <BlockHeadContent>
                        <BlockTitle>Consignment Report</BlockTitle>
                        <ul className="list list-sm" id="list-note">
                        <li>All data is from 24th February, 2023 onwards</li>                        
                      </ul>
                    </BlockHeadContent>
                </BlockBetween>
            </BlockHead>

            <Block>
                <Row>          

                                   
                    {/* <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>PO Level Status</h5>
                            {purchaseOrderAPICall?.isLoading ? 
                            <div style={{textAlign: 'center'}}>                            
                                <Spinner size="xl" color="light" />
                            </div>                    
                        :
                            <div className="card-inner-group">                        
                                            
                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                        <th scope="col">Status</th>
                                        <th scope="col">Unique PO's</th>
                                        <th scope="col">Unique Items</th>
                                        <th scope="col">Received By Aza</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {purchaseOrderData?.po_level_arr?.map((data) => {          
                                        return (
                                            <tr>
                                                <td>{data["Purchase Order Level Status"]}</td> 
                                                <td>{data["po_number"]}</td>      
                                                <td>{data["aza code"]}</td>
                                                <td>{data["Inwarded"]}</td>
                                            </tr>
                                        );
                                        })}
                                    </tbody>
                                </table>

                            </div>
}
                        </Card>
                    </Col> */}

                  
                    <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Current Status Of Items</h5>
                            {purchaseOrderAPICall?.isLoading ? 
                            <div style={{textAlign: 'center'}}>                            
                                <Spinner size="xl" color="light" />
                            </div>                    
                        :
                            <div className="card-inner-group">                        
                                            
                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                        <th scope="col">Status</th>
                                        <th scope="col">Unique Items</th>
                                        <th scope="col">Share of Items</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {purchaseOrderData?.item_level_arr?.map((data) => {          
                                        return (
                                            <tr>
                                                <td>{data["Item Level Status"]}</td> 
                                                <td>{data["aza code"]}</td>      
                                                <td>{data["aza code %"]}%</td>
                                            </tr>
                                        );
                                        })}
                                    </tbody>
                                </table>

                            </div>
}
                        </Card>
                    </Col>
                                   
                    {/* <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Quality Check History</h5>
                            {purchaseOrderAPICall?.isLoading ? 
                            <div style={{textAlign: 'center'}}>                            
                                <Spinner size="xl" color="light" />
                            </div>                    
                        :
                            <div className="card-inner-group">                        
                                            
                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                        <th scope="col">Status</th>
                                        <th scope="col">Unique Items</th>
                                        <th scope="col">Share of Items</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {purchaseOrderData?.qc_historic_arr?.map((data) => {          
                                        return (
                                            <tr>
                                                <td>{data["QC FAIL Historic"]}</td>                                                 
                                                <td>{data["aza code"]}</td>
                                                <td>{data["aza code %"]}%</td>
                                            </tr>
                                        );
                                        })}
                                    </tbody>
                                </table>

                            </div>
}
                        </Card>
                    </Col> */}


                                                    
                    {/* <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Quality Check Status (Items Remaining With Aza)</h5>
                            {purchaseOrderAPICall?.isLoading ? 
                            <div style={{textAlign: 'center'}}>                            
                                <Spinner size="xl" color="light" />
                            </div>                    
                        :
                            <div className="card-inner-group">                        
                                            
                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                        <th scope="col">Status</th>
                                        <th scope="col">Unique Items</th>
                                        <th scope="col">Share of Items</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {purchaseOrderData?.qc_level_arr?.map((data) => {          
                                        return (
                                            <tr>
                                                <td>{data["Current QC Status"]}</td>                                                 
                                                <td>{data["aza code"]}</td>
                                                <td>{data["aza code %"]}%</td>
                                            </tr>
                                        );
                                        })}
                                    </tbody>
                                </table>

                            </div>
}
                        </Card>
                    </Col> */}
                </Row>
            </Block>
        </Content>
        <ToastContainer />
    </>)
};

export default PurchaseOrderCharts;